import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private toastr: ToastrService,
    private keycloakService: KeycloakService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      withCredentials: false,
    });

    return next
      .handle(req)
      .pipe(catchError(error => this.interceptErrors(error)));
  }

  login(): void {
    this.keycloakService.login({ redirectUri: environment.feUrl });
  }

  private interceptErrors(response: any): Observable<never> {

    if (response.error instanceof ProgressEvent) {
      this.keycloakService.isLoggedIn().then((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          this.login();
        }
      }
      );
    }

    if (response.status === 500) {
      this.toastr.error('Something went wrong');
    }

    return throwError(response);
  }
}
